import React from "react";

const Footer = () => {
  return (
    <>
      {/* /.content-wrapper */}
      <footer className="main-footer text-center">
        <div className="pull-right d-none d-sm-inline-block"></div>
        {new Date().getFullYear()} © <a href="javascript:void(0);" className="">xendaya Admin Panel</a>. Restricted Area
      </footer>
    </>
  );
};
export default Footer;
